<template>
	<div class="root">
		<TableBlock ref="tableData" :columns="cloumn" :action="action" :param="param" :navHeight="270">
			<div class="common-space-between">
				<div class="common-items-center">
					<el-input v-model="param.keyword" ref="keyWord" style="width:150px;margin-right: 10px;"
						:size="this.$store.state.btnSize" placeholder="请输入内容"></el-input>
					<Month title="操作日期" ref="mouth" @getDate="getDate"></Month>
					<el-button class="btn-heigth" type="primary" icon="el-icon-search" :size="this.$store.state.btnSize"
						@click="searchBtn">搜索</el-button>
					<el-button class="btn-heigth" type="danger" icon="el-icon-refresh" :size="this.$store.state.btnSize"
						@click="resetBtn">重置</el-button>

				</div>
				<div>
					<el-button type="primary" icon="el-icon-plus" size="small" @click="addBtn">新增</el-button>
				</div>
			</div>
		</TableBlock>
		<AddBlock ref="add"></AddBlock>
		<queryBlock ref="query"></queryBlock>
	</div>
</template>

<script>
import { operate } from '@/utils/config'
import { getFun } from '@/utils/httpFun'
import { columns } from './index.js'
import Month from '@/components/component-block/block-month.vue'
import AddBlock from './add-block-problem.vue'
import queryBlock from './block-query.vue'

export default {
	components: {
		Month: Month,
		AddBlock: AddBlock,
		queryBlock: queryBlock
	},
	data() {
		return {
			cloumn: [],
			action: operate.PROBLEMLIST,
			param: {
				endTime: null,
				startTime: null,
				keyword: null,
				publishPlatform: null,
				operator: null
			}
		};
	},
	created() {
		this.cloumn = columns(this);
	},
	mounted() {

	},
	methods: {

		searchBtn() {
			this.$refs.tableData.getDatas()
		},
		resetBtn() {
			this.$refs.mouth.clear()
			this.$refs.tableData.resetHttp()
			this.$refs.keyWord.clear()
			this.param.startTime = null
			this.param.endTime = null
		},
		//获取时间
		getDate(ev) {
			this.param.startTime = ev.startDate+" 00:00:00"
			this.param.endTime = ev.endDate+" 23:59:59"
		},
		//查看
		lookBtn(ev) {
			console.log(ev)
			this.$refs.query.showMessage("", ev);
		},
		//编辑
		eidtBtn(ev) {
			this.$refs.add.showMessage("eidt", ev);

		},
		//删除
		async deleteBtn(ev) {
			console.log(ev)
			let parms = {
				id: ev.id
			}
			this.$confirm('是否删除项目?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				getFun(operate.DELATEPROBLE, parms, res => {
					if(res.data){
						this.$message.success("删除成功");
						this.resetBtn()
					}else{
						this.$message.warning("删除失败");
					}
					
				})
			})



		},
		//添加 
		addBtn(ev) {
			this.$refs.add.showMessage("add", {});

		}
	}
}
</script>

<style lang="scss" scoped></style>